import React, { useEffect, useRef, useState } from "react";
import { apiCall } from "../../../../utils/axiosService";
import { API_URL } from "../../../../utils/apiRoutes";
import { apiResponse } from "../../../../utils/apiResponse";
import { Button, Col, Table } from "react-bootstrap";
import { commonService } from "../../../../utils/commonService";
import NoteIcon from "../../../../Assets/Images/CRM/notes.svg";
import downloadIcon from "../../../../Assets/Images/Operation/downloadIcon.svg";
import Loader from "../../../Loader/Loader";
import DatePicker from "react-datepicker";
import WidgetDetailModal from "../../WidgetDetailModal";
import { compName } from "../../../../utils/constant";
import infoIcon from "../../../../Assets/Images/Action Icons/infoIcon..svg";
import { useSelector } from "react-redux";
import WidgetNote from "../../WidgetNote";
import AddWidgetModal from "../../AddWidgetModal";
import { useParams } from "react-router-dom";
import emailIcon from "../../../../Assets/Images/Email.svg";
import moment from "moment";

const ChoiceRes = ({
  setCompDataFromChild,
  rowIndex,
  colIndex,
  api,
  para,
  setting,
}) => {
  const tableData = [
    {
      id: 1,
      propertyCode: "AC32AW",
      pullDateId: "494",
      AsOfDate: "2023-08-16",
      Account: "319227559",
      GuestName: "JONES, CODY",
      Arrive: "2014-01-02",
      Depart: "2014-01-05",
      Nights: "3",
      Status: "O",
      Rate: "SRD RATE",
      RateCode: "SRD Rate",
      Type: "NK",
      Room: "209.0",
      Source: "CRS",
      CRSConfNo: "58388260.0",
      GTD: "DB",
      ReserveDate: "2014-01-02",
      ReserveTime: null,
      User: "CRS",
      SharedAccount: "N",
      TrackCode: "Corporate",
      Package: "",
      CancellationDate: "",
      CancellationTime: null,
      CXLUserID: "",
    },
    {
      id: 1,
      propertyCode: "AC32AW",
      pullDateId: "494",
      AsOfDate: "2023-08-16",
      Account: "319227559",
      GuestName: "JONES, CODY",
      Arrive: "2014-01-02",
      Depart: "2014-01-05",
      Nights: "3",
      Status: "O",
      Rate: "SRD RATE",
      RateCode: "SRD Rate",
      Type: "NK",
      Room: "209.0",
      Source: "CRS",
      CRSConfNo: "58388260.0",
      GTD: "DB",
      ReserveDate: "2014-01-02",
      ReserveTime: null,
      User: "CRS",
      SharedAccount: "N",
      TrackCode: "Corporate",
      Package: "",
      CancellationDate: "",
      CancellationTime: null,
      CXLUserID: "",
    },
    {
      id: 1,
      propertyCode: "AC32AW",
      pullDateId: "494",
      AsOfDate: "2023-08-16",
      Account: "319227559",
      GuestName: "JONES, CODY",
      Arrive: "2014-01-02",
      Depart: "2014-01-05",
      Nights: "3",
      Status: "O",
      Rate: "SRD RATE",
      RateCode: "SRD Rate",
      Type: "NK",
      Room: "209.0",
      Source: "CRS",
      CRSConfNo: "58388260.0",
      GTD: "DB",
      ReserveDate: "2014-01-02",
      ReserveTime: null,
      User: "CRS",
      SharedAccount: "N",
      TrackCode: "Corporate",
      Package: "",
      CancellationDate: "",
      CancellationTime: null,
      CXLUserID: "",
    },
    {
      id: 1,
      propertyCode: "AC32AW",
      pullDateId: "494",
      AsOfDate: "2023-08-16",
      Account: "319227559",
      GuestName: "JONES, CODY",
      Arrive: "2014-01-02",
      Depart: "2014-01-05",
      Nights: "3",
      Status: "O",
      Rate: "SRD RATE",
      RateCode: "SRD Rate",
      Type: "NK",
      Room: "209.0",
      Source: "CRS",
      CRSConfNo: "58388260.0",
      GTD: "DB",
      ReserveDate: "2014-01-02",
      ReserveTime: null,
      User: "CRS",
      SharedAccount: "N",
      TrackCode: "Corporate",
      Package: "",
      CancellationDate: "",
      CancellationTime: null,
      CXLUserID: "",
    },
    {
      id: 1,
      propertyCode: "AC32AW",
      pullDateId: "494",
      AsOfDate: "2023-08-16",
      Account: "319227559",
      GuestName: "JONES, CODY",
      Arrive: "2014-01-02",
      Depart: "2014-01-05",
      Nights: "3",
      Status: "O",
      Rate: "SRD RATE",
      RateCode: "SRD Rate",
      Type: "NK",
      Room: "209.0",
      Source: "CRS",
      CRSConfNo: "58388260.0",
      GTD: "DB",
      ReserveDate: "2014-01-02",
      ReserveTime: null,
      User: "CRS",
      SharedAccount: "N",
      TrackCode: "Corporate",
      Package: "",
      CancellationDate: "",
      CancellationTime: null,
      CXLUserID: "",
    },
    {
      id: 1,
      propertyCode: "AC32AW",
      pullDateId: "494",
      AsOfDate: "2023-08-16",
      Account: "319227559",
      GuestName: "JONES, CODY",
      Arrive: "2014-01-02",
      Depart: "2014-01-05",
      Nights: "3",
      Status: "O",
      Rate: "SRD RATE",
      RateCode: "SRD Rate",
      Type: "NK",
      Room: "209.0",
      Source: "CRS",
      CRSConfNo: "58388260.0",
      GTD: "DB",
      ReserveDate: "2014-01-02",
      ReserveTime: null,
      User: "CRS",
      SharedAccount: "N",
      TrackCode: "Corporate",
      Package: "",
      CancellationDate: "",
      CancellationTime: null,
      CXLUserID: "",
    },
    {
      id: 1,
      propertyCode: "AC32AW",
      pullDateId: "494",
      AsOfDate: "2023-08-16",
      Account: "319227559",
      GuestName: "JONES, CODY",
      Arrive: "2014-01-02",
      Depart: "2014-01-05",
      Nights: "3",
      Status: "O",
      Rate: "SRD RATE",
      RateCode: "SRD Rate",
      Type: "NK",
      Room: "209.0",
      Source: "CRS",
      CRSConfNo: "58388260.0",
      GTD: "DB",
      ReserveDate: "2014-01-02",
      ReserveTime: null,
      User: "CRS",
      SharedAccount: "N",
      TrackCode: "Corporate",
      Package: "",
      CancellationDate: "",
      CancellationTime: null,
      CXLUserID: "",
    },
    {
      id: 1,
      propertyCode: "AC32AW",
      pullDateId: "494",
      AsOfDate: "2023-08-16",
      Account: "319227559",
      GuestName: "JONES, CODY",
      Arrive: "2014-01-02",
      Depart: "2014-01-05",
      Nights: "3",
      Status: "O",
      Rate: "SRD RATE",
      RateCode: "SRD Rate",
      Type: "NK",
      Room: "209.0",
      Source: "CRS",
      CRSConfNo: "58388260.0",
      GTD: "DB",
      ReserveDate: "2014-01-02",
      ReserveTime: null,
      User: "CRS",
      SharedAccount: "N",
      TrackCode: "Corporate",
      Package: "",
      CancellationDate: "",
      CancellationTime: null,
      CXLUserID: "",
    },
    {
      id: 1,
      propertyCode: "AC32AW",
      pullDateId: "494",
      AsOfDate: "2023-08-16",
      Account: "319227559",
      GuestName: "JONES, CODY",
      Arrive: "2014-01-02",
      Depart: "2014-01-05",
      Nights: "3",
      Status: "O",
      Rate: "SRD RATE",
      RateCode: "SRD Rate",
      Type: "NK",
      Room: "209.0",
      Source: "CRS",
      CRSConfNo: "58388260.0",
      GTD: "DB",
      ReserveDate: "2014-01-02",
      ReserveTime: null,
      User: "CRS",
      SharedAccount: "N",
      TrackCode: "Corporate",
      Package: "",
      CancellationDate: "",
      CancellationTime: null,
      CXLUserID: "",
    },
    {
      id: 1,
      propertyCode: "AC32AW",
      pullDateId: "494",
      AsOfDate: "2023-08-16",
      Account: "319227559",
      GuestName: "JONES, CODY",
      Arrive: "2014-01-02",
      Depart: "2014-01-05",
      Nights: "3",
      Status: "O",
      Rate: "SRD RATE",
      RateCode: "SRD Rate",
      Type: "NK",
      Room: "209.0",
      Source: "CRS",
      CRSConfNo: "58388260.0",
      GTD: "DB",
      ReserveDate: "2014-01-02",
      ReserveTime: null,
      User: "CRS",
      SharedAccount: "N",
      TrackCode: "Corporate",
      Package: "",
      CancellationDate: "",
      CancellationTime: null,
      CXLUserID: "",
    },
  ];

  const date = new Date();
  const startDate = commonService.getDateInDBFormat(
    new Date(date.getFullYear(), date.getMonth(), 1)
  );
  const endDate = commonService.getDateInDBFormat(
    new Date(date.getFullYear(), date.getMonth() + 1, 0)
  );

  const [choiceResData, setChoiceResData] = useState(null);
  const [loading, setLoading] = useState(false);
  const [startRangeDate, setStartRangeDate] = useState();
  const [endRangeDate, setEndRangeDate] = useState();
  const startRangeDateRef = useRef();
  const endRangeDateRef = useRef();
  const [widgetModal, setWidgetModal] = useState(false);
  const widgetDetailRef = useRef();
  const [showNoteSidebar, setShowNoteSidebar] = useState(false);
  const [openDatePicker, setOpenDatePicker] = useState(false);
  const propertyDetailFromRTK = useSelector(
    (store) => store.headerProperty.propertyDetail
  );
  const defaultAsOfDateFromRTK = useSelector(
    (store) => store.headerProperty.defaultAsOfDate
  );
  const { snapshottitle, propertyCode, snapshotId } = useParams();
  const closeNoteSideBar = () => {
    setShowNoteSidebar(false);
  };

  const closeWidgetModal = () => {
    setWidgetModal(false);
  };
  const handleDateChange = (event) => {
    const [start, end] = event;
    let startSelectedDate = "",
      endSelectedDate = "";
    if (start) {
      let date = new Date(start);
      let month =
        date.getMonth() + 1 > 9
          ? date.getMonth() + 1
          : `0${date.getMonth() + 1}`;
      let dateFormat =
        date?.getDate() > 9 ? date.getDate() : `0${date.getDate()}`;
      startSelectedDate = `${date.getFullYear()}-${month}-${dateFormat}`;
      startRangeDateRef.current = startSelectedDate;
    }
    if (end) {
      let date = new Date(end);
      let month =
        date.getMonth() + 1 > 9
          ? date.getMonth() + 1
          : `0${date.getMonth() + 1}`;
      let dateFormat =
        date?.getDate() > 9 ? date.getDate() : `0${date.getDate()}`;
      endSelectedDate = `${date.getFullYear()}-${month}-${dateFormat}`;
      endRangeDateRef.current = endSelectedDate;
    }

    setStartRangeDate(event[0]);
    setEndRangeDate(event[1]);
    if (event[0] !== null && event[1] !== null) {
      // getChoiceResDetail();
    }
  };

  const getChoiceResDetail = async () => {
    setLoading(true);
    let payload = {
      AsOfDate: para?.asOfDate,
      propertyCode: para?.propertyCode,
    };

    if (startRangeDateRef.current && endRangeDateRef.current) {
      payload = {
        ...payload,
        startDate: startRangeDateRef.current,
        endDate: endRangeDateRef.current,
      };
    }
    let choiceDetailResponse = await apiCall(
      {
        method: "POST",
        url: API_URL.BASE_API_URL.SnapShot + API_URL.CHOICE_RES.CHOICE_RES,
        body: payload,
        // body: {
        //   AsOfDate: para?.asOfDate,
        //   startDate: "2023-08-01",
        //   endDate: "2023-08-31",
        //   propertyCode: "AC32AW",
        // },
      },
      false
    );

    let response = apiResponse(false, choiceDetailResponse);

    if (response?.isValidate) {
      setChoiceResData(response?.data?.data);
      setLoading(false);
    }

    if (!response?.isValidate) {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (api === 0) {
      setChoiceResData(tableData);
    } else {
      if (para?.asOfDate) {
        getChoiceResDetail();
      }
    }
  }, [para?.asOfDate]);

  const [tblids, settblids] = useState({
    tblChoiceRes: commonService.GenerateGUID(),
  });

  return (
    <div className="widget-container" style={{position: "relative"}}>
      {api !== 0 && (
        <div className="gap-1 widget-container-menu">
          <Button className="heading-menu-btns" type="button">
            <img id={commonService.generateGlobalClickTrackerID("ChoiceRes", "menuicon", propertyCode)}
              src={NoteIcon}
              alt="menuIcon"
              onClick={() => {
                setShowNoteSidebar(true);
              }}
            />
          </Button>
          <Button className="heading-menu-btns" type="button" title="Send Mail">
            <img id={commonService.generateGlobalClickTrackerID("ChoiceRes", "emailicon", propertyCode)}
              src={emailIcon}
              alt="emailIcon"
              onClick={() => {
                commonService.fnSendWidgetMail(
                  tblids.tblChoiceRes,
                  "Choice Reservation",
                  snapshotId,
                  defaultAsOfDateFromRTK,
                  "",
                  para?.widgetId
                );
              }}
            />
          </Button>
          <Button className="heading-menu-btns" type="button">
            <img id={commonService.generateGlobalClickTrackerID("ChoiceRes", "info", propertyCode)}
              src={infoIcon}
              alt="info"
              onClick={() => {
                widgetDetailRef.current = {
                  widgetdetails: "",
                  usernote: "",
                  compName: compName?.choiceRes,
                  widgetId: para?.widgetId,
                };
                setWidgetModal(true);
              }}
            />
          </Button>
          <Button className="heading-menu-btns" type="button">
            <img id={commonService.generateGlobalClickTrackerID("ChoiceRes", "menuicon", propertyCode)}
              src={downloadIcon}
              alt="menuIcon"
              import={tblids.tblChoiceRes}
              onClick={() =>
                commonService.fnExportInCSV(
                  tblids.tblChoiceRes,
                  // "Choice Reservation"
                  `${para?.propertyCode}-Choice Reservation-${moment(
                    new Date()
                  ).format("MMDDYYYY")}`
                )
              }
            />
          </Button>
        </div>
      )}
      <div className="ViewPropertySetupTable">
        <div className="stripped__table">
        <div className="table-responsive tblDynamicPickupSticky">
          <Table id={tblids.tblChoiceRes} className="positionStaticTable">
            <thead className="tbl-header-sticky">
              <tr className="table-main-header-tr">
                <th id={commonService.generateGlobalClickTrackerID("ChoiceRes", "date-as-of-date", propertyCode)}
                  className="width175"
                  onClick={() => {
                    setOpenDatePicker(true);
                  }}
                >
                  Date{" "}
                                      <DatePicker id={commonService.generateGlobalClickTrackerID("ChoiceRes", "date-as-of-date", propertyCode)}
                                          portalId="datepicker-root"
                    onChange={(event) => handleDateChange(event)}
                    startDate={startRangeDate}
                    endDate={endRangeDate}
                    selectsRange
                    monthsShown={2}
                    open={openDatePicker}
                    shouldCloseOnSelect={false}
                  >
                    <div className="w-100" style={{ display: "inline-block" }}>
                      <div className="content-inside-calendar">
                        <p>
                          {startRangeDate
                            ? commonService.getDateInFormat(startRangeDate)
                            : ""}
                          {startRangeDate && endRangeDate ? " - " : ""}
                          {endRangeDate
                            ? commonService.getDateInFormat(endRangeDate)
                            : ""}
                        </p>
                        <div className="d-flex align-items-center gap-2">
                          <button id={commonService.generateGlobalClickTrackerID("ChoiceRes", "date-as-of-date", propertyCode)}
                            className="secondary-btn"
                            onClick={(e) => {
                              e.stopPropagation();
                              setStartRangeDate("");
                              setEndRangeDate("");
                              setOpenDatePicker(false);
                            }}
                          >
                            Cancel
                          </button>
                          <button id={commonService.generateGlobalClickTrackerID("ChoiceRes", "date-as-of-date", propertyCode)}
                            disabled={
                              startRangeDate && endRangeDate ? false : true
                            }
                            onClick={(e) => {
                              e.stopPropagation();
                              if (
                                startRangeDateRef.current &&
                                endRangeDateRef.current
                              ) {
                                getChoiceResDetail();
                              }

                              setOpenDatePicker(false);
                            }}
                            className="primary-btn"
                          >
                            Apply
                          </button>
                        </div>
                      </div>
                    </div>
                  </DatePicker>
                  {startRangeDate && endRangeDate && (
                    <span
                      style={{ display: "none" }}
                    >{`${commonService.getDateInFormat(
                      startRangeDate
                    )} - ${commonService.getDateInFormat(endRangeDate)}`}</span>
                  )}
                </th>
                <th colSpan={24}></th>
              </tr>
              <tr className="table-main-header-tr">
                {/* <th className="width150">property Code</th>
                <th className="width150">pullDate Id</th> */}
                <th className="width150">As Of Date</th>
                <th className="width150">Account</th>
                <th className="width150">Guest Name</th>
                <th className="width150">Arrive</th>
                <th className="width150">Depart</th>
                <th className="width150">Nights</th>
                <th className="width150">Status</th>
                <th className="width150">Rate</th>
                <th className="width150">Rate Code</th>
                <th className="width150">Type</th>
                <th className="width150">Room</th>
                <th className="width150">Source</th>
                <th className="width150">CRS Conf No</th>
                <th className="width150">GTD</th>
                <th className="width150">Reserve Date</th>
                <th className="width150">Reserve Time</th>
                <th className="width150">User</th>
                <th className="width150">Shared Account</th>
                <th className="width150">Track Code</th>
                <th className="width150">Package</th>
                <th className="width150">Cancellation Date</th>
                <th className="width150">Cancellation Time</th>
                <th className="width150">CXL User ID</th>
              </tr>
            </thead>
            <tbody>
              {loading ? (
                <tr style={{ height: "80px", position: "relative" }}>
                  <Loader />
                </tr>
              ) : choiceResData ? (
                choiceResData?.map((item, index) => (
                  <tr key={index} className="shadowOnHover">
                    {/* <td>{item?.propertyCode}</td>
                    <td>{item?.pullDateId}</td> */}
                    <td>{commonService?.getDateInFormat(item?.AsOfDate)}</td>
                    <td>{item?.Account}</td>
                    <td>{item?.GuestName}</td>
                    <td>{commonService?.getDateInFormat(item?.Arrive)}</td>
                    <td>{commonService?.getDateInFormat(item?.Depart)}</td>
                    <td>{item?.Nights}</td>
                    <td>{item?.Status}</td>
                    <td>{item?.Rate}</td>
                    <td>{item?.RateCode}</td>
                    <td>{item?.Type}</td>
                    <td>{item?.Room}</td>
                    <td>{item?.Source}</td>
                    <td>{item?.CRSConfNo}</td>
                    <td>{item?.GTD}</td>
                    <td>{commonService?.getDateInFormat(item?.ReserveDate)}</td>
                    <td>{item?.ReserveTime}</td>
                    <td>{item?.User}</td>
                    <td>{item?.SharedAccount}</td>
                    <td>{item?.TrackCode}</td>
                    <td>{item?.Package}</td>
                    <td>{item?.CancellationDate}</td>
                    <td>{item?.CancellationTime}</td>
                    <td>{item?.CXLUserID}</td>
                  </tr>
                ))
              ) : (
                <tr>No Data Found</tr>
              )}
            </tbody>
          </Table>
          </div>
        </div>
      </div>
      {/* {showNoteSidebar && (
        <WidgetNote
          show={showNoteSidebar}
          handleClose={closeNoteSideBar}
          widgetId={para?.widgetId}
          propertyId={propertyDetailFromRTK?.propertyid}
          rowTitle={para?.rowTitle}
        />
      )} */}
      {showNoteSidebar && (
        <AddWidgetModal
          showModal={showNoteSidebar}
          closeModal={closeNoteSideBar}
          widgetId={para?.widgetId}
          propertyId={propertyDetailFromRTK?.propertyid}
          rowTitle={para?.rowTitle}
        />
      )}
      {widgetModal && (
        <WidgetDetailModal
          showModal={widgetModal}
          closeModal={closeWidgetModal}
          data={widgetDetailRef.current}
        />
      )}
    </div>
  );
};

export default ChoiceRes;
